/**
 * Created by Kaku.Guo on 2019/7/19.
 */
/* eslint-disable react/prop-types*/
import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import cn from 'classnames';
import { getMessage, ValidateTextArea, ValidateSelect } from '../index';
import { getReviewReportValidations } from '../../data';

const REPORT_TYPE = [
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.report.type.unwanted_spam', value: 'Unwanted spam'},
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.report.type.sexually_explicit', value: 'Sexually Explicit material'},
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.report.type.hate_speech', value: 'Hate speech / graphic violence'},
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.report.type.harassment', value: 'Harassment'},
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.report.type.inaccuracy', value: 'Inaccuracy'}
];

function ReviewReportContent(props, ref) {
    const prefixCls = 'review-report-content';
    const { className, messages, isDisabled, defaultValue = {} } = props;
    const { abuseType, content } = defaultValue;

    const typeRef = useRef(null);
    const contentRef = useRef(null);

    useImperativeHandle(ref, () => ({
        getValue: () => {
            const type = typeRef.current.getValue();
            const cont = contentRef.current.getValue();
            if (!type || !cont) {
                return false;
            }
            return {
                abuseType: type.value,
                content: cont.value
            };
        }
    }));

    const reportTypeOptions = REPORT_TYPE.map(it => ({
        text: getMessage(messages, it.label),
        value: it.value
    }));

    const classNames = cn(prefixCls, className);
    const validations = getReviewReportValidations(messages);
    return (
        <div className={classNames}>
            <ValidateSelect
                ref={typeRef}
                className={`${prefixCls}__type`}
                placeholder={getMessage(messages, 'messages.com.epicgames.plugin.store.asset.reviews.report.type.placeholder')}
                isDisabled={isDisabled}
                defaultValue={abuseType}
                options={reportTypeOptions}
                validateRule={validations.abuseType} />
            <ValidateTextArea
                ref={contentRef}
                className={`${prefixCls}__content`}
                placeholder={getMessage(messages, 'messages.com.epicgames.plugin.store.asset.reviews.report.content.placeholder')}
                disabled={isDisabled}
                defaultValue={content}
                validateRule={validations.content}
                required />
        </div>
    );
}

export default forwardRef(ReviewReportContent);